/* global $ */
import intl from 'react-intl-universal'

import { setStoryAns } from '~/redux/storyData'

export default [
  '$scope',
  'authorService',
  '$ngRedux',
  'toastr',
  // eslint-disable-next-line @typescript-eslint/no-use-before-define
  AuthorSelection,
]

const defaultGuest = {
  name: '',
  org: '',
  type: 'author',
  additional_properties: {
    original: {
      author_type: '',
    },
  },
}

function AuthorSelection($scope, authorService, $ngRedux, toastr) {
  this.$onInit = () => {
    // TODO This is for the repeater.... argh
    this.storyObj &&
      this.storyObj.credits &&
      this.storyObj.credits.by &&
      this.storyObj.credits.by.forEach((a) => {
        if (!a._id) {
          if (a.type === 'reference') {
            a._id = a.referent.id
          } else {
            a._id = '_guest' + Math.ceil(Math.random() * 10000)
          }
        }
      })
  }

  this.intl = intl
  this.guest = { ...defaultGuest }
  this.showGuest = false

  this.addGuest = () => {
    this.guest = { ...defaultGuest }
    this.showGuest = true
  }

  this.cancel = () => {
    this.guest = { ...defaultGuest }
    this.showGuest = false
  }

  this.insertGuest = () => {
    if (!this.guest.name.length) {
      toastr.error(intl.get('authorSelection.insertGuest.error'))
      return
    }
    // need an id for repeater since it can not work via index.
    this.guest._id = '_guest' + Math.ceil(Math.random() * 10000)
    this.storyObj.credits.by.push(this.guest)
    this.updateRedux()
    this.guest = { ...defaultGuest }
    this.showGuest = false
  }

  this.fetchAuthors = (val) =>
    authorService
      .searchName(val)
      .then((authors = []) => {
        // If user is already added do not show in autocomplete
        // MCO has BAD data and have multiple authors with same id.... so we need to filter until they get it cleaned up.
        const ids = this.storyObj.credits.by.map((o) => o._id).filter((k) => k)
        return authors.reduce(
          ({ acc, dupes }, obj) => {
            if (!ids.includes(obj._id) && !dupes[obj._id]) {
              acc.push({
                ...obj,
                // need to display byline or name in view, adjust model here
                uiDisp:
                  obj.additional_properties.original.byline ||
                  obj.name ||
                  obj._id,
              })
            }
            dupes[obj._id] = true
            return { acc, dupes }
          },
          { acc: [], dupes: {} }
        ).acc
        // const result = authors.filter(o => ids.indexOf(o._id) === -1)
        // const _ids = {}
        // return result.filter(o => {
        // if (_ids[o.id]) return false
        // _ids[o.id] = true
        // return true
        // })
      })
      .catch(this.errorCapture)

  this.addCurrentUser = () => {
    let email
    try {
      email = window.localStorage.getItem('arc.email')
    } catch (e) {
      if (process.env.NODE_ENV === 'testing') {
        console.warn('author selection local storage fail', e)
      }
    }

    if (email) {
      authorService.searchByEmail(email).then(
        (result) => {
          if (result.count) {
            const details = result.q_results[0]
            const userExists = this.storyObj.credits.by.some(
              (author) => author._id === details._id
            )
            if (userExists) {
              toastr.error(intl.get('authorSelection.authorNotFound.error'))
            } else {
              this.storyObj.credits.by.push(details)
              this.updateRedux()
            }
          } else {
            this.cantFindEmail()
          }
        },
        (error) => {
          this.cantFindEmail()
          console.error(error)
        }
      )
    } else {
      this.cantFindEmail()
    }
  }

  this.cantFindEmail = () => {
    toastr.error(intl.get('authorSelection.authorNotFound.error'))
  }

  this.author_fields = [
    'byline',
    'firstName',
    'lastName',
    'email',
    'image',
    'role',
    'twitter',
    'beat',
  ].map((key) => ({
    key,
    label: intl.get(`authorSelection.authorFields.${key}`),
  }))

  this.compSettings = () => {
    // TODO The company settings points to the wrong part of the object...
    // Need to track down why....
    return $scope.$root.globalSettings
  }

  // this.$onInit = () => {
  const cs = this.compSettings()
  this.authorExtraField = cs && cs.edit && cs.edit.authorExtraField
  // }

  this.editAuthor = (author) => {
    const cs = this.compSettings()
    const canOverrideAuthor = cs && cs.edit && cs.edit.overrideAuthor
    if (!canOverrideAuthor) return

    // prevent invalid ANS due to uninflated authors
    if (author.type && author.type === 'reference') return

    // const isAuthorReference = author._id !== undefined
    const isAuthorReference = author._id.indexOf('_guest') === -1
    this.isAuthorReference = isAuthorReference

    if (isAuthorReference) {
      this.selectedAuthorOrg = author.additional_properties.original
      author.referent_properties = author.referent_properties || {}
      author.referent_properties.additional_properties =
        author.referent_properties.additional_properties || {}
      author.referent_properties.additional_properties.original =
        author.referent_properties.additional_properties.original || {}
      this.selectedAuthorRPO =
        author.referent_properties.additional_properties.original
    } else {
      // Guest Author
      this.selectedGuestAuthor = author
    }

    // this has to be some selector to work appaently - just wrapping the $element won't work ~awt
    $('#authorEdit').modal('show')
  }

  this.tagAdded = this.tagRemoved = () => {
    this.updateRedux()
  }

  this.updateRedux = () => {
    this.storyObj.isDirty = true
    $ngRedux.dispatch(
      setStoryAns({
        storyAns: this.storyObj,
        isDirty: true,
      })
    )
  }
}
